import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function TwoPaths() {
  return <section className="py-24 bg-white" data-id="element-333">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-334">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-335">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-stone-900 mb-8" data-id="element-336">
            Llegaste hasta aquí por una razón.
          </h2>

          <div className="space-y-6 text-stone-600 text-lg md:text-xl leading-relaxed mb-12" data-id="element-337">
            <p data-id="element-338">No fue casualidad.</p>
            <p data-id="element-339">Algo dentro de ti ya reconoció… que no quiere seguir igual.</p>

            <p className="text-2xl text-stone-800 font-medium my-10 font-serif" data-id="element-340">
              Y ahora tienes dos opciones:
            </p>

            <p data-id="element-341">
              Seguir postergando… o hacer un pequeño cambio que puede alterar
              todo.
            </p>
            <p data-id="element-342">No necesitas más información. No necesitas estar 100% segura.</p>

            <p className="text-2xl md:text-3xl font-serif text-[#C5A059] font-bold italic mt-10" data-id="element-343">
              Solo necesitas decidir:
            </p>
            <p className="text-xl md:text-2xl text-stone-900 font-bold mt-4" data-id="element-344">
              👉 ¿Sigues repitiendo el patrón… o empiezas a cambiarlo hoy?
            </p>
            <p className="text-red-400 font-medium italic mt-6" data-id="element-345">
              Esta página no va a aparecer de nuevo de la misma forma.
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-346">
            <a href="https://pay.hotmart.com/L105538443T" target="_blank" rel="noopener noreferrer" onClick={() => {
            if ((window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout');
            }
          }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-lg font-bold text-stone-900 rounded-full overflow-hidden shadow-[0_0_30px_rgba(197,160,89,0.3)] transition-all hover:shadow-[0_0_50px_rgba(197,160,89,0.5)] hover:scale-105 w-full md:w-auto" data-id="element-347">
              <div className="absolute inset-0 gold-gradient" data-id="element-348"></div>
              <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-349"></div>
              <span className="relative flex items-center gap-2 text-center" data-id="element-350">
                👉 Sí… hoy dejo de repetir el mismo patrón
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform shrink-0" data-id="element-351" />
              </span>
            </a>
            <p className="text-stone-500 text-sm font-medium" data-id="element-352">
              👉 Acceso inmediato. Empiezas hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}